import R from "./index.es245.js";
import j from "./index.es244.js";
import E from "./index.es246.js";
import O from "./index.es247.js";
function p(t, r) {
  var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (e) return (e = e.call(t)).next.bind(e);
  if (Array.isArray(t) || (e = X(t)) || r) {
    e && (t = e);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X(t, r) {
  if (t) {
    if (typeof t == "string") return b(t, r);
    var e = {}.toString.call(t).slice(8, -1);
    return e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set" ? Array.from(t) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? b(t, r) : void 0;
  }
}
function b(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var e = 0, n = Array(r); e < r; e++) n[e] = t[e];
  return n;
}
function B(t) {
  var r = t.data, e = t.sheetName, n = t.sheetNames, s = t.schema, a = t.columns, o = t.images, u = t.headerStyle, l = t.getHeaderStyle, h = t.fontFamily, S = t.fontSize, w = t.orientation, A = t.stickyRowsCount, C = t.stickyColumnsCount, F = t.showGridLines, I = t.rightToLeft, L = t.dateFormat, y = E(), k = y.getSharedStrings, T = y.getSharedString, d = j({
    fontFamily: h,
    fontSize: S
  }), H = d.getStyles, N = d.getStyle;
  if (n && a && !Array.isArray(a[0]))
    throw new Error('In a "write multiple sheets" scenario, `columns` parameter must be an array of `columns` for each sheet.');
  n || (n = [e || "Sheet1"], r = [r], a && (a = [a]), s && (s = [s]), o && (o = [o])), u && !l && (l = function() {
    return u;
  });
  for (var x = p(n), g; !(g = x()).done; ) {
    var z = g.value;
    O(z);
  }
  for (var c = [], i = 0, G = p(n), f; !(f = G()).done; )
    f.value, c.push(R(r[i], {
      schema: s && s[i],
      columns: a && a[i],
      images: o && o[i],
      getHeaderStyle: l,
      getStyle: N,
      getSharedString: T,
      customFont: h || S,
      dateFormat: L,
      orientation: w,
      stickyRowsCount: A,
      stickyColumnsCount: C,
      showGridLines: F,
      rightToLeft: I,
      sheetId: i + 1
    })), i++;
  return {
    sheets: n.map(function(v, m) {
      return {
        id: m + 1,
        name: v,
        data: c[m],
        images: o && o[m]
      };
    }),
    getSharedStrings: k,
    getStyles: H
  };
}
export {
  B as generateSheets
};
//# sourceMappingURL=index.es218.js.map
